import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../ui/button";
import { LogOut, Hospital } from "lucide-react";

export const PortalLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col bg-[#F2F4F5]">
      <header className="flex items-center justify-between h-16 px-4 md:px-8 border-b-2 border-nexus-gold bg-nexus-blue text-white sticky top-0 z-30">
        <button type="button" data-testid="portal-home-link" onClick={() => navigate("/strutture")} className="flex items-center gap-3 min-w-0">
          <span className="bg-white rounded-md px-2 py-1"><img src="/nexus_logo.png" alt="Nexus Italia Group" className="h-7 w-auto object-contain" /></span>
          <span className="hidden sm:flex items-center gap-2 rounded-md px-3 py-1.5 text-xs font-semibold bg-white/10 text-nexus-gold border border-nexus-gold/50">
            <Hospital className="h-4 w-4" /> Portale Strutture Sanitarie
          </span>
        </button>
        <div className="flex items-center gap-3">
          <span data-testid="portal-user-name" className="hidden md:block text-sm text-white/80 truncate max-w-[260px]">{user?.name}</span>
          <Button data-testid="portal-logout" size="sm" variant="ghost" className="gap-2 text-white hover:bg-white/10 hover:text-nexus-gold"
            onClick={async () => { await logout(); navigate("/strutture/login"); }}>
            <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Esci</span>
          </Button>
        </div>
      </header>
      <main className="flex-1 p-4 md:p-8"><div className="max-w-5xl mx-auto nx-fade-in">{children}</div></main>
    </div>
  );
};
